<template>
  <div>

    <xolas-table
          hide-org-badge
    ref="sitesways"
    table-ref="site_ways"

    title="Sites Ways"
    icon="fa fa-sort-numeric-up"

    url="/view/sites/ways"

    trackBy="ways"
    sortField="ways"

    :fields="fields" />

 </div>

</template>

<script>

export default {

  props: {

    ways: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
      // minWidth hints mirror the pre-migration vuetable-2 render, measured at
      // 1504px viewport (.context/xol-234-baselines/metrics.json,
      // sites-ways-table[3] — the 14-column "Ways" detail table) — el-table
      // distributes un-sized columns equally, which does not match the legacy
      // content-based auto layout.
      fields: [
        {
          name: 'ways',
          title: 'Ways',
          minWidth: 46,
        },
        {
          name: 'status',
          title: 'Status',
          minWidth: 55,
        },
        {
          name: 'siteId',
          title: 'Site ID',
          minWidth: 55,
        },
        {
          name: 'siteGroup',
          title: 'Site Group',
          minWidth: 89,
        },
        {
          name: 'coverage',
          title: 'Coverage',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          minWidth: 81
        },
        {
          name: 'handover',
          title: 'Handover',
          callback: this.formatDate,
          minWidth: 83,
        },
        {
          name: 'postCode',
          title: 'Post Code',
          minWidth: 86,
        },
        {
          name: 'subdistrict',
          title: 'Sub District',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: 98
        },
        {
          name: 'state',
          title: 'State',
          minWidth: 45,
        },
        {
          name: 'country',
          title: 'Country',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: 67
        },
        {
          name: 'latitude',
          title: 'Latitude',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          minWidth: 72

        },
        {
          name: 'longitude',
          title: 'Longitude',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: 88
        },
        {
          name: 'shortName',
          title: 'PM',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          minWidth: 27
        },

      ]
    }
  }
}

</script>

<!-- Dev-parity: zero horizontal cell padding + tight line-height to match the
     legacy vuetable-2 render (dev <td> uses `12px 0`). -->
<style scoped>
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { padding-left: 0; padding-right: 0; }
::v-deep .el-table th .cell { white-space: normal; }
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { line-height: 1.25; }
</style>
